import React from 'react';
import { Left, Right, Top, Bottom } from './BorderStyles';

const Border = () => {
  return (
    <>
      <Left />
      <Right />
      <Top />
      <Bottom />
    </>
  );
};

export default Border;
